/**
 * Parse query string parameters from URL
 * @param {string} queryString - The query string to parse (e.g., "?param1=value1&param2=value2")
 * @returns {Object} - An object containing the parsed parameters
 */
export const parseQueryString = (queryString) => {
  const params = {};
  
  // Remove the leading '?' if present
  const query = queryString.startsWith('?') ? queryString.substring(1) : queryString;
  
  // Split the query string by '&' to get individual key-value pairs
  const pairs = query.split('&');
  
  // Process each key-value pair
  for (const pair of pairs) {
    // Skip empty pairs
    if (!pair) continue;
    
    // Split the pair by '=' to get the key and value
    const [key, value] = pair.split('=');
    
    // Decode the key and value and add them to the params object
    if (key) {
      params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
    }
  }
  
  return params;
};

/**
 * Format currency value
 * @param {number} amount - The amount to format
 * @param {string} currency - The currency symbol (default: '¥')
 * @returns {string} - Formatted currency string
 */
export const formatCurrency = (amount, currency = '¥') => {
  return `${currency}${parseFloat(amount).toFixed(2)}`;
};

/**
 * Generate a random order ID
 * @param {string} prefix - Prefix for the order ID (default: 'ORDER')
 * @returns {string} - Generated order ID
 */
export const generateOrderId = (prefix = 'ORDER') => {
  const timestamp = new Date().getTime();
  const random = Math.floor(Math.random() * 1000);
  return `${prefix}${timestamp}${random}`;
};
